module.exports = __webpack_public_path__ + "static/img/7.6664bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/03/7.png
// module id = eq+7
// module chunks = 1